<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-card
            class="pa-1 mb-1"
            @click="loadMessagesChat(chatId)"
            :color="model.client.id === selectedChatId ? 'blue lighten-4' : ''"
    >
        <v-list-item class="px-1">
            <v-list-item-content class="pa-1 ma-0">
                <v-list-item-title class="title body-2">
                    <a :href="url" target="_blank">{{userName}}</a><br>
                    <v-tooltip right>
                        <template v-slot:activator="{ on }">
                                <span
                                        v-on="on"
                                        class="text-center align-self-center"
                                >{{formattedDate}} {{formattedTime}}</span>
                        </template>
                        <span class="caption">Дата создания события</span>
                    </v-tooltip>
                </v-list-item-title>
                <v-list-item-subtitle class="title body-2">
                    {{model.body}}
                </v-list-item-subtitle>
            </v-list-item-content>
        </v-list-item>
    </v-card>
</template>

<script>
import axios from 'axios'
import ConstConf from '../../../constconf'
import { mapGetters } from 'vuex'

export default {
    name: 'EventCard',
    props: ['model', 'index', 'status', 'selectedChatId'],
    methods: {
        zero(number) {
            if (number < 10) {
                number = '0' + number
            }
            return number
        },
        loadMessagesChat() {
            this.$emit('loadMessagesChat', this.model.client)
        }
    },
    computed: {
        formattedDate() {
            let theDate = new Date(this.model.created_at * 1000)
            return this.zero(theDate.getDate()) + '.' + this.zero((theDate.getMonth() + 1)) + '.' + theDate.getFullYear()
        },
        formattedTime() {
            let theDate = new Date(this.model.created_at * 1000)
            return this.zero(theDate.getHours()) + ':' + this.zero((theDate.getMinutes()))
        },
        showBadge() {
            return this.model.status === 'warning'
        },
        url() {
            return '/bot' + this.model.bot_id + '/client/' + this.model.client.user_id
        },
        userName() {
            if (((this.model.client.last_name ? this.model.client.last_name.length : 0) + (this.model.client.first_name ? this.model.client.first_name.length : 0) + (this.model.client.username ? this.model.client.username.length : 0)) === 0) {
                return 'noname'
            } else {
                return this.model.client.last_name + ' ' + this.model.client.first_name + (!this.model.client.username ? '' : ' (' + this.model.client.username + ')')
            }
        },
        chatId() {
            return this.model.client.id
        }
    },
    created() {

    }
}
</script>

<style scoped>

</style>
